import { AuthStatus, UserLevel } from 'project-config/constants'
import {
  NormalIcon,
  SilverIcon,
  GoldIcon,
  PlatinumIcon,
  DiamondIcon,
  DiamondStudentIcon,
  PictureNormalIcon,
  PictureVipIcon,
} from 'task-eva-ui/assets/icons'
import { getTranslateNsT } from '@/utils/get-translate-nst'

export const getUserLevelIcon = (level: number) => {
  return {
    [UserLevel.PictureNormal]: <PictureNormalIcon />,
    [UserLevel.PictureVip]: <PictureVipIcon />,
    [UserLevel.Normal]: <NormalIcon />,
    [UserLevel.Sliver]: <SilverIcon />,
    [UserLevel.Gold]: <GoldIcon />,
    [UserLevel.Platinum]: <PlatinumIcon />,
    [UserLevel.Diamond]: <DiamondIcon />,
    [59]: <DiamondStudentIcon />,
  }[level]
}

export function getAuthStatusTranslate(status: number, isStudent?: boolean, isPersonal?: boolean) {
  const t = getTranslateNsT('common')
  if (isStudent && isPersonal) return t('status-6-student')
  switch (status) {
    case AuthStatus.PersonalAuthSuccess:
    case AuthStatus.PersonalToEnterpriseFailed:
      return t('status-6')
    case AuthStatus.PersonaChangeFailed:
    case AuthStatus.PersonalChanging:
      return t('status-6')
    case AuthStatus.Changing:
      return isPersonal ? t('status-6') : t('enterprise_certify')
    case AuthStatus.EnterpriseAuthSuccess:
    case AuthStatus.EnterpriseChangeFailed:
      return t('enterprise_certify')
    default:
      return t('no_certify')
  }
}
